import React, { PropTypes } from 'react'
import styled from 'styled-components'
import CloseIcon from '../../svg-icons/CloseIcon'
import { Colors, Fonts, Metrics } from '../../Themes'
import LeftArrow from '../../svg-icons/LeftArrow'

const LeftArrowContainer = styled(LeftArrow)`
  margin-top: -${Metrics.margins.small};
  fill: ${Colors.darkGrey}
`

const Close = styled.div`
  position: absolute;
  right: ${Metrics.margins.base};
  top: ${Metrics.margins.base};
  z-index: 1;
  transition: ease transform 0.2s;
`

const Container = styled.div`
  position: fixed;
  display: ${props => (props.visible ? 'block' : 'none')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  ${Fonts.style.Text};
`

const Overlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  backgroundColor: ${Colors.overlay};
`

const ModalContainer = styled.div`
  background: ${Colors.white};
  z-Index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${Metrics.components.modalWidth};
  max-height: ${Metrics.components.modalHeight};
  overflow: hidden;
  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    height: 100vh;
    width: 100vw;
    max-height: none;
    box-shadow: none;
  }
`

const HeaderContainer = styled.div`
  height: auto;
  padding: ${Metrics.margins.large};
  text-align: center;
  position: relative;
  ${Fonts.style.Header};
  color: ${Colors.primary};

  .back {
    position: absolute;
    top: ${Metrics.margins.larger};
    left: ${Metrics.margins.larger};
    cursor: pointer;
  }
`

const FooterContainer = styled.div`
  height: auto;
  padding: ${Metrics.margins.base} 0;
  text-align: center;
`

const BodyContainer = styled.div`
  padding: ${Metrics.margins.large} 80px;
  max-height: ${Metrics.components.modalContainer};
  overflow-y: scroll;
  text-align: center;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: ${Metrics.margins.large} ${Metrics.margins.big};
    max-height: 80vh;
  }
`

const Modal = props => {
  const {
    children,
    closeAction,
    visible,
    header,
    footer,
    style,
    backAction,
    modalClassName
  } = props

  const headerComponent = header ? (
    <HeaderContainer className='header'>
      {backAction && (
        <LeftArrowContainer className='back' onClick={() => backAction()} />
      )}
      {header}
    </HeaderContainer>
  ) : (
    ''
  )

  const footerContainer = footer ? (
    <FooterContainer>{footer}</FooterContainer>
  ) : (
    ''
  )

  const closeIcon = closeAction ? (
    <Close onClick={closeAction}>
      <CloseIcon />
    </Close>
  ) : (
    ''
  )

  return (
    <Container visible={visible} className={modalClassName} {...props}>
      <Overlay />
      <ModalContainer className='modalContainer'>
        {closeIcon}
        {headerComponent}
        <BodyContainer style={style} id='modal-body'>
          {children}
        </BodyContainer>
        {footerContainer}
      </ModalContainer>
    </Container>
  )
}

Modal.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.node,
  closeAction: PropTypes.func,
  backAction: PropTypes.func,
  header: PropTypes.node,
  footer: PropTypes.node,
  style: PropTypes.object,
  modalClassName: PropTypes.string
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/index.js